import React from 'react';

import withActivateUtr from '../../components/hocs/withActivateUtr';
import NuoV2PageWrapper from '../NuoV2';

const Onboarding = () => <NuoV2PageWrapper />;

export default withActivateUtr(Onboarding);
